import React from 'react';
import { FaRocket, FaRobot, FaChartLine, FaHandshake } from 'react-icons/fa';
import ServiceCard from '../../Components/ServiceCard';
import beliefs from '../../data/AboutSectionData/beliefsData';


const BeliefsSection = () => {
  return (
    <section className="bg-bgDefault text-white lg:py-24 px-5 py-12 lg:px-12">
      <div className='container xl:mx-auto xl:max-w-screen-xl'>
      <h2 className="text-heading-4 md:text-heading-1 font-dmsans tracking-[-0.06em] mb-10" data-aos="fade-right"><font class="font-bold ">How We Work </font> <font class="text-[#9E9E9E]">The CARE Framework</font></h2>
      
      <p className="md:text-body text-body-sm text-[#9E9E9E] font-roboto mb-6">
          At Techxplore, every partnership begins with trust and shared purpose. We believe technology alone doesn’t drive success—collaboration, accountability, and a relentless focus on results do. That’s why we follow our <b>CARE Framework</b>, a philosophy that defines how we engage, deliver, and grow alongside our clients.
        </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 ">
        

        {beliefs.map((item, index) => (
           <div
            key={index}
            data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1000"
            data-aos-delay={index * 200} 
          >
            <ServiceCard
              key={index}
              image={item.image}
              title={item.title}
              desc={item.description}
            />
             </div>
          ))}

      </div>
      </div>
    </section>
  );
};

export default BeliefsSection;
